import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import headerEN from "./locales/en/header.json";
import headerHY from "./locales/hy/header.json";
import headerRU from "./locales/ru/header.json";
import homeEN from "./locales/en/home.json";
import homeHY from "./locales/hy/home.json";
import homeRU from "./locales/ru/home.json";
import aboutEN from "./locales/en/about.json";
import aboutHY from "./locales/hy/about.json";
import aboutRU from "./locales/ru/about.json";
import errorEN from "./locales/en/error.json";
import errorHY from "./locales/hy/error.json";
import errorRU from "./locales/ru/error.json";
import contactEN from "./locales/en/contact.json";
import contactHY from "./locales/hy/contact.json";
import contactRU from "./locales/ru/contact.json";
import footerEN from "./locales/en/footer.json";
import footerHY from "./locales/hy/footer.json";
import footerRU from "./locales/ru/footer.json";
import groupToursEN from "./locales/en/groupTours.json";
import groupToursHY from "./locales/hy/groupTours.json";
import groupToursRU from "./locales/ru/groupTours.json";
import privateToursEN from "./locales/en/privateTours.json";
import privateToursHY from "./locales/hy/privateTours.json";
import privateToursRU from "./locales/ru/privateTours.json";
import topToursEN from "./locales/en/topTours.json";
import topToursHY from "./locales/hy/topTours.json";
import topToursRU from "./locales/ru/topTours.json";
import tourCarsEN from "./locales/en/tourCars.json";
import tourCarsHY from "./locales/hy/tourCars.json";
import tourCarsRU from "./locales/ru/tourCars.json";
import authEN from "./locales/en/auth.json";
import authHY from "./locales/hy/auth.json";
import authRU from "./locales/ru/auth.json";
import reviewsEN from "./locales/en/reviews.json";
import reviewsHY from "./locales/hy/reviews.json";
import reviewsRU from "./locales/ru/reviews.json";


const resources = {
  en: {
    header: headerEN,
    home: homeEN,
    about: aboutEN,
    error: errorEN,
    contact: contactEN,
    footer: footerEN,
    groupTours: groupToursEN,
    privateTours: privateToursEN,
    topTours: topToursEN,
    tourCars: tourCarsEN,
    auth: authEN,
    reviews: reviewsEN,
  },
  hy: {
    header: headerHY,
    home: homeHY,
    about: aboutHY,
    error: errorHY,
    contact: contactHY,
    footer: footerHY,
    groupTours: groupToursHY,
    privateTours: privateToursHY,
    topTours: topToursHY,
    tourCars: tourCarsHY,
    auth: authHY,
    reviews: reviewsHY,
  },
  ru: {
    header: headerRU,
    home: homeRU,
    about: aboutRU,
    error: errorRU,
    contact: contactRU,
    footer: footerRU,
    groupTours: groupToursRU,
    privateTours: privateToursRU,
    topTours: topToursRU,
    tourCars: tourCarsRU,
    auth: authRU,
    reviews: reviewsRU,
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: "hy",
    ns: [
      "header",
      "home",
      "about",
      "error",
      "contact",
      "footer",
      "groupTours",
      "privateTours",
      "topTours",
      "tourCars",
      "auth",
      "reviews"
    ],
    defaultNS: "home",
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
